// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__nTDux"};